<template>
  <div id="dashboard-index">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${this.serviceSlug}`) },
        { title: this.$t('check-up_plus.dashboard'), disabled: true }
    ]">
    </Breadcrumbs>


    <div class="text-center" v-if="isLoading">
      <LoadingAnimation></LoadingAnimation>
    </div>
    <div v-else>
      <div class="row mt-2 no-gutters evollu-form">
        <div class="row">
          <div class="col-4">
            <label class="form-label">
              {{ $t('dashboard_new_evollu.kpis.filters.timePeriod.title') }}
            </label>
            <multiselect
              id="entities-filter"
              v-model="filters.period"
              :options="timePeriods"
              track-by="id"
              :custom-label="opt => $t(`dashboard_new_evollu.kpis.filters.timePeriod.${opt.slug}`, 'N/A')"
              :placeholder="$t('dashboard_new_evollu.kpis.filters.timePeriod.title')"
              :allow-empty="false"
              :multiple="false"
              :internal-search="true"
            />
          </div>

          <div class="col-12 col-md-4">
            <label class="form-label">
              {{ $t('activities_agenda.table.facility') }}
            </label>
            <multiselect
              id="entities-filter"
              v-model="filters.facility"
              :options="readableFacilities"
              track-by="id"
              :customLabel="formatedEntityLabel"
              :placeholder="$t('activities_agenda.table.facility')"
              :allow-empty="true"
              :multiple="false"
              :internal-search="true"
              :disabled="!readableFacilities.length || readableFacilities.length === 1"
            >

              <template slot="clear">
                <span class="multiselect__clear" v-if="filters.facility !== null"
                      @mousedown.prevent.stop="filters.facility = null"></span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>
      <GraphsDashboard
        class="mt-4"
        :readableFacilities="readableFacilities"
        :hasWritePermission="hasWritePermission"
        :timePeriods="timePeriods"
        :filters="filters"
      />

      <KpisDashboard
        class="mt-4"
        :readableFacilities="readableFacilities"
        :timePeriods="timePeriods"
        :filters="filters"
      />



    </div>


  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import GraphsDashboard from "@/components/checkup_plus/dashboard/GraphsDashboard";
import KpisDashboard from '@/components/checkup_plus/dashboard/KpisDashboard.vue';
import LoadingAnimation from "@/components/users/components/Helpers/LoadingAnimation";
import RangeDatePicker from "@/components/common/RangeDatePicker";
import Multiselect from 'vue-multiselect'
import MultiselectLabelFormatter from "@/mixins/MultiselectLabelFormatter";
import ClustersAndEntitiesMixin from "@/mixins/ClustersAndEntitiesMixin";
import Filters from '@/components/common/Filters'
import LocalStorageHelper from "@/local-storage/LocalStorageHelper";
import {CHECkUP_PLUS_PATIENTS_TABLE} from "@/local-storage/LocalStorageKeys";

const DASHBOARD_INFO_TYPE = 110;

export default {
  mixins: [
    MultiselectLabelFormatter,
    ClustersAndEntitiesMixin
  ],
  components: {RangeDatePicker, LoadingAnimation, GraphsDashboard, Breadcrumbs, Multiselect, Filters, KpisDashboard},
  props: {
    component: {
      type: Object,
      required: true,
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  async created() {
    //this.isLoading = true
    //await this.loadLocalStorage()
    //this.isLoading = false
  },
  data: function () {
    return {
      isLoading: false,
      entityOptions: [],
      filters: {
        facility: null,
        period: {
          id: 2,
          slug: 'lastMonth'
        },
      },
      timePeriods: [
        {
          id: 0,
          slug: 'lastDay'
        },
        {
          id: 1,
          slug: 'lastWeek'
        },
        {
          id: 2,
          slug: 'lastMonth'
        },
        {
          id: 3,
          slug: 'last3Months'
        },
        {
          id: 4,
          slug: 'last6Months'
        },
        {
          id: 5,
          slug: 'lastYear'
        }
      ],
    }
  },
  methods: {
    /*loadLocalStorage: function () {
      return new Promise((resolve, reject) => {
        const state = LocalStorageHelper.get(CHECkUP_PLUS_PATIENTS_TABLE)
        if (state !== null) {
          this.filters = {
            ...this.filters,
            ...state
          }
        }
        resolve()
      })
    },*/
  },
  computed: {
    checkupPlusService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.onecare_server) || null
    },
    readableEntities: function () {
      if (!this.checkupPlusService) {
        return []
      }
      let permissions = this.checkupPlusService.user_permissions.filter(
        p => p.info_type === DASHBOARD_INFO_TYPE && p.access_type >= this.$store.state.accessTypes.READ
      )

      if (permissions.some(p => p.entity_id === null)) {
        return [...this.checkupPlusService.entities]
      } else {
        return this.checkupPlusService.entities.filter(entity => permissions.some(p => p.entity_id === entity.id))
      }
    },
    readableFacilities: function () {
      if (!this.readableEntities.length) {
        return []
      }
      const facilities = this.readableEntities.map(entity => entity.facilities).flat()
      if (facilities.length === 1) {
        this.filters.facility = facilities[0]
      }
      return facilities
    },
    hasWritePermission: function () {
      if (!this.checkupPlusService) {
        return false
      }
      return this.checkupPlusService.user_permissions.some(p => p.info_type === DASHBOARD_INFO_TYPE && p.access_type >= this.$store.state.accessTypes.WRITE)
    }
  }
}
</script>

<style scoped>

</style>
